import { HeadFlashIcon } from './HeadFlashIcon';

/**
 * author: Michael Irigoyen
 * id 86AC6B0F-62ED-4691-88DB-A95DF86CBFF9
 * name head-flash
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-flash.svg
 * tags
 */
export const HeadAcheIcon = HeadFlashIcon;
export default HeadAcheIcon